import { ref } from "vue";
import { useRegisterSW } from "virtual:pwa-register/vue";

const updateAvailable = ref(false);
const isUpdating = ref(false);

let updateSWFn: ((reloadPage?: boolean) => Promise<void>) | null = null;

export function usePwaUpdate() {
  const { needRefresh, updateServiceWorker } = useRegisterSW({
    onRegisteredSW(swUrl, registration) {
      if (registration) {
        setInterval(
          () => {
            registration.update();
          },
          60 * 60 * 1000,
        );
      }
    },
  });

  updateSWFn = updateServiceWorker;

  if (needRefresh.value) {
    updateAvailable.value = true;
  }

  return {
    needRefresh,
    updateAvailable,
    isUpdating,

    async applyUpdate() {
      if (!updateSWFn) return;
      isUpdating.value = true;
      try {
        await updateSWFn(true);
      } finally {
        isUpdating.value = false;
        updateAvailable.value = false;
      }
    },

    dismissUpdate() {
      updateAvailable.value = false;
    },

    showUpdatePrompt() {
      if (needRefresh.value) {
        updateAvailable.value = true;
      }
    },
  };
}
